import Box from "@mui/material/Box";
import Button from "components/Buttons/Button/Button";
import Buttons from "components/Buttons/Buttons/Buttons";
import { AutocompleteInput, FilePicker, FormInput, InputCheckbox, InputDateTime } from "components/Form/FormInputs/FormInput";
import React, { useState } from "react";
import scss from "../NewReclamation/NewReclamation.module.scss";
import useAPI from "hooks/useAPI";
import { toast } from "react-toastify";
import { useEffect } from "react";
import Divider from "@mui/material/Divider";
import { useTranslation } from "react-i18next";
import { printError } from "../../../../helpers/apiError";

const AdditionalSection = ({ onInitDataChange = () => {}, index = -1, itemsArray = [], translateKey, item, allowedReceipts = "all" }) => {
    const { t } = useTranslation();

    const api = useAPI();

    // const [loading, setLoading] = useState(false);
    const [selectedValue, setSelectedValue] = useState("");
    const [storeReceipt, setStoreReceipt] = useState({});
    const [isIdNull, setIsIdNull] = useState(true);
    const [purchaseDate, setPurchaseDate] = useState(null);
    const [productSku, setProductSku] = useState("");
    const [productName, setProductName] = useState("");
    const [descriptionReclamatins, setDescriptionReclamatins] = useState({});
    const [optionsProducts, setOptionsProducts] = useState([]);
    const [isChecked, setIsChecked] = useState([]);
    const [responsiveType, setResponsiveType] = useState([]);
    

    const [selectedFiles, setSelectedFiles] = useState([]);
    const apiPathNew = `/reclamations/new/order_items/${selectedValue}`;
    const apiResponsiveTypes =`reclamations/new/ddl/responsive_type`;

    const handleValueChange = (newValue) => {
        setSelectedValue(newValue);
    };

    const submitHandlerReclamationsNewId = () => {
        if (!selectedValue) {
            toast.warn(t("reclamations-default-messages-fill_required_fields"));
            return;
        }

        api.get(apiPathNew)
            .then((response) => {
                if (response.id === null && allowedReceipts === "online") {
                    toast.warn(t("reclamations-new-additional-messages-receipt_not_found"));
                    return;
                }

                if (response.id === null) {
                    setIsIdNull(true);

                    setPurchaseDate(null);
                    setDescriptionReclamatins({});
                } else {
                    setIsIdNull(false);
                    setPurchaseDate(new Date(response.created_at));
                    setProductSku("");
                    setProductName("");
                    setDescriptionReclamatins({});
                }
                const { items } = response;
                let arr = [];
                items?.forEach((item, i) => {
                    let count = 0;
                    itemsArray?.forEach((it) => {
                        if (it?.id_product === item?.id_product) {
                            count++;
                        }
                    });
                    if (count < Number(item?.quantity)) {
                        arr.push({ ...item });
                    }
                });
                if (response?.id !== null) {
                    if (arr.length > 0) {
                        setOptionsProducts(arr);
                        onInitDataChange(index, "pretraga", { ...response, fiscal_clip: selectedValue });
                    } else {
                        onInitDataChange(index, "nema_proizvoda", null);
                    }
                } else {
                    setOptionsProducts(arr);
                    onInitDataChange(index, "pretraga", { ...response, fiscal_clip: selectedValue });
                }
            })
            .catch((error) => {
                toast.warn(printError(error) ? printError(error) : t("global-message-unknown_error"));
            });
    };

    const handleRemoveClick = () => {
        setSelectedValue("");
        setStoreReceipt({});
        setIsIdNull(true);
        setPurchaseDate(null);
        setOptionsProducts([]);
        setProductSku("");
        setProductName("");
        setDescriptionReclamatins({});
        setIsChecked([]);
        setSelectedFiles([]);
        onInitDataChange(index, "ukloni", null);
    };

    const handlerResponsiveTypes = () => {
        api.get(apiResponsiveTypes)
            .then((response) => {
                setResponsiveType(response);
            })
            .catch((error) => {
                toast.warn(printError(error) ? printError(error) : t("global-message-unknown_error"));
            });
    };


    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        let isCheckedTemp = [...isChecked];
        if (checked) {
            isCheckedTemp.push(name);
        } else {
            isCheckedTemp = isCheckedTemp.filter((item) => item !== name);
        }
        setIsChecked(isCheckedTemp);
        onInitDataChange(index, "responsive_type", isCheckedTemp);
    };

    useEffect(() => {
        handlerResponsiveTypes();
    }, [])

    useEffect(() => {
        if (storeReceipt?.receipt_number) {
            onInitDataChange(index, "pretraga", { id: null, fiscal_clip: storeReceipt.receipt_number });
        }
    }, [storeReceipt]);

    useEffect(() => {
        onInitDataChange(index, "product_sku", productSku?.product_sku === undefined ? null : productSku?.product_sku);
    }, [productSku]);

    useEffect(() => {
        onInitDataChange(index, "product_name", productName?.product_name === undefined ? null : productName?.product_name);
    }, [productName]);

    useEffect(() => {
        onInitDataChange(index, "description", descriptionReclamatins?.description === undefined ? "" : descriptionReclamatins?.description);
    }, [descriptionReclamatins]);

    return (
        <>
            <>
                {allowedReceipts === "store" ? (
                    <>
                        <FormInput
                            label={`${translateKey}-form-field-order_numbers-label`}
                            field="receipt_number"
                            data={storeReceipt}
                            setData={setStoreReceipt}
                            required={true}
                            columns={10}
                        />
                        {item.fiscal_clip && (
                            <Buttons className={`${scss.buttonInfoAboutRec} col-sm-2`}>
                                <Button label={`${translateKey}-button-remove`} onClick={handleRemoveClick} className={scss.buttonRemove} />
                            </Buttons>
                        )}
                    </>
                ) : (
                    <>
                        <AutocompleteInput
                            label={`${translateKey}-form-field-order_numbers-label`}
                            fillFromApi={"reclamations/new/ddl/order_numbers"}
                            usePropName={false}
                            columns={10}
                            description={`${translateKey}-description`}
                            required={true}
                            value={selectedValue}
                            disabled={item.fiscal_clip || item.order_slug ? true : false}
                            onChange={(value) => {
                                //Case 1: {id: 'B2B-2023-000002', name: 'B2B-2023-000002'}
                                //Case 2: 123
                                //Case 3: {inputValue: '123', name: 'Dodaj: "123"'}
                                if (value === "" || value === null) {
                                    handleRemoveClick();
                                } else {
                                    if (typeof value === "object") {
                                        if (value?.id === undefined) {
                                            handleValueChange(value?.inputValue);
                                        } else {
                                            handleValueChange(value?.name);
                                        }
                                    } else {
                                        handleValueChange(value);
                                    }
                                }
                            }}
                        />
                        <Buttons className={`${scss.buttonInfoAboutRec} col-sm-2`}>
                            <Button
                                label={`${translateKey}-form-button-submit`}
                                onClick={submitHandlerReclamationsNewId}
                                className={scss.buttonSearch}
                                buttonStyleBasic={{ display: item.fiscal_clip || item.order_slug ? "none" : "flex" }}
                            />
                            {(item.fiscal_clip || item.order_slug) && <Button label={`${translateKey}-button-remove`} onClick={handleRemoveClick} className={scss.buttonRemove} />}
                        </Buttons>
                    </>
                )}
            </>
            {(item.fiscal_clip || item.order_slug) && (
                <>
                    <InputDateTime
                        label={`${translateKey}-form-field-purchase_date-label`}
                        required={true}
                        columns={4}
                        className={scss.formInputInfoAboutRec}
                        value={purchaseDate}
                        disabled={!isIdNull}
                        onChange={(e) => {
                            setPurchaseDate(e.target.value);
                            onInitDataChange(index, "date", e.target.value);
                        }}
                    />

                    {isIdNull ? (
                        <>
                            <FormInput
                                label={`${translateKey}-form-field-product_sku-label`}
                                field="product_sku"
                                data={productSku}
                                required={true}
                                setData={setProductSku}
                                className={scss.formInputInfoAboutRec}
                                columns={4}
                            />
                            <FormInput
                                label={`${translateKey}-form-field-product_name-label`}
                                field="product_name"
                                data={productName}
                                required={true}
                                setData={setProductName}
                                className={scss.formInputInfoAboutRec}
                                columns={4}
                            />
                        </>
                    ) : (
                        <>
                            <AutocompleteInput
                                label={`${translateKey}-form-field-product-label`}
                                usePropName={false}
                                columns={8}
                                required
                                onChange={(selectedValue) => {
                                    onInitDataChange(index, "product", selectedValue);
                                }}
                                options={optionsProducts}
                                className={scss.formInputInfoAboutRec}
                            />
                        </>
                    )}
                    <FormInput
                        label={`${translateKey}-form-field-description-label`}
                        data={descriptionReclamatins}
                        setData={setDescriptionReclamatins}
                        type="textarea"
                        field={"description"}
                        required={true}
                        rows={4}
                        className={scss.formInputInfoAboutRec}
                        columns={12}
                    />

                    <Box sx={{ margin: "0.5rem 0 0.25rem 0" }}>
                        <p style={{ marginBottom: "0" }}>
                            {t("reclamations-new-additional-solution-title")}
                            {responsiveType && <span style={{ color: "var(--croonus-alertRed)", paddingLeft: "0.25em" }}>*</span>}
                        </p>
                        {responsiveType?.map((item) => {
                            return <InputCheckbox key={item.id} label={item.name} name={item.name} value={isChecked.includes(item.name)} onChange={handleCheckboxChange} required={true} />;
                        })}
                    </Box>

                    <FilePicker
                        label={`${translateKey}-form-field-select_file-label`}
                        className={scss.formInputInfoAboutRec}
                        selectedFile={selectedFiles}
                        onFilePicked={(file) => {
                            setSelectedFiles([...selectedFiles, file]);
                            onInitDataChange(index, "file", [...selectedFiles, file]);
                        }}
                        multipleFileSelection={true}
                        handleRemoveFile={(file) => {
                            const updatedFiles = selectedFiles.filter((item) => item.name !== file.name);
                            setSelectedFiles(updatedFiles);
                            onInitDataChange(index, "file", updatedFiles);
                        }}
                    />

                    <Divider sx={{ display: itemsArray.length > 1 ? "block" : "none", margin: "1rem 0", borderColor: "var(--croonus-darkGray)", opacity: "1" }} />
                </>
            )}
        </>
    );
};

export default AdditionalSection;
